export const randomInRange = (min, max) => {
  return Math.random() * (max - min) + min
}

// taken and modified from https://stackoverflow.com/a/48764436
// rounds half away from zero
export const round = (options) => {
  if (options === undefined) {
    console.warn("Warning: round() was called without an argument object")
    return
  }

  const { num, decimalPlaces = 2 } = options

  if (num === null || num === undefined) {
    console.warn("Warning: round() was called with a null or undefined value")
    return
  }

  if (num < 0)
    return -round({ num: -num, decimalPlaces })

  const rounded = Math.round(Number(num + "e" + decimalPlaces))
  return Number(rounded + "e" + -decimalPlaces)
}
